import React, { useState, useEffect } from "react";
import {
  FiPieChart,
  FiGrid,
  FiList,
  FiPlus,
  FiPlay,
  FiAward,
  FiClock,
  FiX,
  FiUsers,
  FiUserCheck,
  FiUserX,
  FiShield,
  FiDollarSign,
  FiTrendingUp,
  FiTrendingDown,
  FiCreditCard,
  FiFileText,
  FiSettings,
  FiBriefcase,
  FiUser,
  FiPower,
  FiChevronDown,
  FiChevronRight,
  FiMenu,
  FiHome,
  FiBarChart2,
  FiGlobe,
  FiShoppingBag,
  FiTerminal,
  FiSend,
  FiMousePointer,
  FiClipboard,
  FiHeadphones,
  FiLayers,
  FiCheckSquare,
  FiTable,
  FiCalendar,
  FiMapPin,
  FiLogIn,
  FiAlertTriangle,
  FiBox,
  FiMessageCircle,
  FiPhone,
  FiCode,
  FiChevronUp,
  FiInfo,
  FiLock,
  FiFile,
  FiUser as FiUserIcon,
} from "react-icons/fi";
import { GiPokerHand, GiCardDraw } from "react-icons/gi";
import { GoProject } from "react-icons/go";
import { MdOutlinePeople } from "react-icons/md";
import {
  FaUsers,
  FaUserCheck,
  FaUserAltSlash,
  FaUser,
  FaHome,
  FaDragon,
  FaUserCog,
  FaUserPlus,
  FaCog,
  FaQrcode,
  FaMoneyBillWave,
  FaHandHoldingUsd,
  FaHistory,
  FaTrophy,
  FaChartLine,
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/king999-logo.png";
import { IoMdSettings } from "react-icons/io";
import { BiTime, BiCheckCircle } from "react-icons/bi";
import { RiBankCard2Line, RiMoneyDollarBoxLine } from "react-icons/ri";

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const [openMenus, setOpenMenus] = useState({});
  const [activePath, setActivePath] = useState("");
  const location = useLocation();

  // Complete menu configuration with original URLs
  const menuSections = [
    {
      id: "dashboard",
      title: "Dashboard",
      icon: FiHome,
      items: [
        {
          id: "dashboard",
          label: "Dashboard",
          icon: FiPieChart,
          path: "/",
          nestedPaths: ["/dashboard", "/home"], // ✅ "/admin" hata diya
        },
      ],
    },
    {
      id: "admin-earning",
      title: "Admin Earning",
      icon: FiDollarSign,
      items: [
        {
          id: "admin-earning",
          label: "Admin Earning",
          icon: FiDollarSign,
          path: "/admin-earning",
          nestedPaths: ["/admin-earning"],
        },
      ],
    },

    {
      id: "admin-manager",
      title: "Admin Manager",
      icon: FaUserCog,
      items: [
        {
          id: "all-admin",
          label: "All Admin",
          icon: FaUsers,
          path: "/admin-list",
          nestedPaths: ["/admins", "/admin-list"],
        },
        {
          id: "add-admin",
          label: "Add Admin",
          icon: FaUserPlus,
          path: "/add-admin",
          nestedPaths: ["/admin/add", "/create-admin"],
        },
        {
          id: "upi-setting",
          label: "Upi Setting",
          icon: RiBankCard2Line,
          path: "/upi-setting",
          nestedPaths: ["/settings/upi", "/upi-settings"],
        },
        {
          id: "qr-setting",
          label: "Qr Setting",
          icon: FaQrcode,
          path: "/qr-setting",
          nestedPaths: ["/settings/qr", "/qr-settings"],
        },
        // ✅ NEW: Account Setting
        {
          id: "account-setting",
          label: "Account Setting",
          icon: FiSettings,
          path: "/account-setting",
          nestedPaths: ["/account-setting", "/settings/account"],
        },
      ],
    },
    {
      id: "user-manager",
      title: "User Manager",
      icon: FaUsers,
      items: [
        {
          id: "all-user",
          label: "All User",
          icon: FiUsers,
          path: "/all-user-list",
          nestedPaths: ["/users", "/user-list"],
        },
        {
          id: "active-user",
          label: "Active User",
          icon: FaUserCheck,
          path: "/active-user-list",
          nestedPaths: ["/users/active", "/active-users"],
        },
        {
          id: "inactive-user",
          label: "Inactive User",
          icon: FaUserAltSlash,
          path: "/inactive-user-list",
          nestedPaths: ["/users/inactive", "/inactive-users"],
        },
        {
          id: "kyc-pending",
          label: "Kyc Pending",
          icon: BiTime,
          path: "/kyc-pending",
          nestedPaths: ["/kyc/pending", "/pending-kyc"],
        },
        {
          id: "kyc-complete",
          label: "Kyc Complete",
          icon: BiCheckCircle,
          path: "/kyc-Verify",
          nestedPaths: ["/kyc/complete", "/completed-kyc"],
        },
        {
          id: "kyc-reject",
          label: "Kyc Reject",
          icon: FiX,
          path: "/kyc-reject",
          nestedPaths: ["/kyc/reject", "/rejected-kyc"],
        },
      ],
    },
    {
      id: "manual-payment",
      title: "Manual Payment",
      icon: FaMoneyBillWave,
      items: [
        {
          id: "deposit-pending",
          label: "Deposit Pending",
          icon: BiTime,
          path: "/deposit-pending",
          nestedPaths: ["/deposit/pending", "/deposits/pending"],
        },
        {
          id: "deposit-approve",
          label: "Deposit Approve",
          icon: BiCheckCircle,
          path: "/deposit-approve",
          nestedPaths: ["/deposit/approve", "/deposits/approved"],
        },
        {
          id: "deposit-Rejected",
          label: "Deposit Rejected",
          icon: FiX,
          path: "/deposit-rejected",
          nestedPaths: ["/deposit/rejected", "/deposits/rejected"],
        },
      ],
    },
    {
      id: "withdraw-payment",
      title: "Withdraw Payment",
      icon: FaHandHoldingUsd,
      items: [
        {
          id: "withdraw-pending",
          label: "Withdraw Pending",
          icon: BiTime,
          path: "/withdrawal-pending",
          nestedPaths: ["/withdraw/pending", "/withdrawals/pending"],
        },
        {
          id: "withdraw-approve",
          label: "Withdraw Approve",
          icon: BiCheckCircle,
          path: "/withdrawal-approve",
          nestedPaths: ["/withdraw/approve", "/withdrawals/approved"],
        },
        {
          id: "withdraw-Rejected",
          label: "Withdraw Rejected",
          icon: FiX,
          path: "/withdrawal-rejected",
          nestedPaths: ["/withdraw/rejected", "/withdrawals/rejected"],
        },
      ],
    },
    {
      id: "transaction-manager",
      title: "Transaction Manager",
      icon: FiCreditCard,
      items: [
        {
          id: "penalty-history",
          label: "Penalty History",
          icon: FiAlertTriangle,
          path: "/penalty-history",
          nestedPaths: ["/transactions/penalty", "/penalty-history"],
        },
        {
          id: "bonus-history",
          label: "Bonus History",
          icon: FiAward,
          path: "/bonus-history",
          nestedPaths: ["/transactions/bonus", "/bonus-history"],
        },
        {
          id: "deposit-history",
          label: "Deposit History",
          icon: FiTrendingUp,
          path: "/deposit-history",
          nestedPaths: ["/transactions/deposit", "/deposit-history"],
        },
        {
          id: "withdraw-history",
          label: "Withdraw History",
          icon: FiTrendingDown,
          path: "/withdraw-history",
          nestedPaths: ["/transactions/withdraw", "/withdraw-history"],
        },
      ],
    },
    {
      id: "report",
      title: "Report",
      icon: FiFileText,
      items: [
        {
          id: "report-penalty",
          label: "Penalty Report",
          icon: FiAlertTriangle,
          path: "/penalty-report",
          nestedPaths: ["/report/penalty", "/penalty-report"],
        },
        {
          id: "report-bonus",
          label: "Bonus Report",
          icon: FiAward,
          path: "/bonus-report",
          nestedPaths: ["/report/bonus", "/bonus-report"],
        },
        {
          id: "report-deposit",
          label: "Deposit Report",
          icon: FiTrendingUp,
          path: "/deposit-report",
          nestedPaths: ["/report/deposit", "/deposit-report"],
        },
        {
          id: "report-withdraw",
          label: "Withdraw Report",
          icon: FiTrendingDown,
          path: "/withdraw-report",
          nestedPaths: ["/report/withdraw", "/withdraw-report"],
        },
      ],
    },
    {
      id: "settings",
      title: "Settings",
      icon: FiSettings,
      items: [
        {
          id: "general-settings",
          label: "General Settings",
          icon: FiSettings,
          path: "/general-settings",
          nestedPaths: ["/settings/general", "/general-settings"],
        },
        {
          id: "content-list",
          label: "Content List",
          icon: FiLock,
          path: "/content-list",
          nestedPaths: ["/settings/privacy", "/content-list"],
        },
        {
          id: "aviator-game-settings-main",
          label: "Aviator Settings",
          icon: FaCog,
          path: "/aviator-game-settings",
          nestedPaths: ["/settings/game", "/game-config"],
        },
        {
          id: "game-settings-main",
          label: "Dragon Tiger Settings",
          icon: FaCog,
          path: "/game-settings",
          nestedPaths: ["/settings/game", "/game-config"],
        },

        {
          id: "mails",
          label: "Mails",
          icon: FaCog,
          path: "/mails",
          nestedPaths: ["/mails", "/game-config"],
        },
        {
          id: "deposit-chfs",
          label: "Deposit Chfs",
          icon: RiBankCard2Line,
          path: "/deposit-chfs",
          nestedPaths: ["/settings/upi", "/deposit-chfs"],
        },
      ],
    },
  ];

  // ============ FIXED: Find active menu item ============
  const findActiveMenuItem = (pathname) => {
    let activeItem = null;
    let activeSection = null;

    // 1. Exact match
    for (const section of menuSections) {
      for (const item of section.items) {
        if (item.path === pathname) {
          activeItem = item;
          activeSection = section;
          return { activeItem, activeSection };
        }
      }
    }

    // 2. Nested paths (with "/" check for safety)
    for (const section of menuSections) {
      for (const item of section.items) {
        if (
          item.nestedPaths &&
          item.nestedPaths.some(
            (nestedPath) =>
              pathname === nestedPath || pathname.startsWith(nestedPath + "/"),
          )
        ) {
          activeItem = item;
          activeSection = section;
          return { activeItem, activeSection };
        }
      }
    }

    // 3. Fallback path check
    for (const section of menuSections) {
      for (const item of section.items) {
        if (pathname.startsWith(item.path + "/")) {
          activeItem = item;
          activeSection = section;
          return { activeItem, activeSection };
        }
      }
    }

    return { activeItem: null, activeSection: null };
  };

  useEffect(() => {
    const currentPath = location.pathname;
    setActivePath(currentPath);

    const { activeItem, activeSection } = findActiveMenuItem(currentPath);

    if (activeSection) {
      setOpenMenus({ [activeSection.id]: true });
    } else if (currentPath !== "/") {
      const isDashboardRelated =
        currentPath.startsWith("/dashboard") || currentPath.includes("admin");
      if (!isDashboardRelated) {
        setOpenMenus({});
      }
    }
  }, [location.pathname]);

  const toggleMenu = (id) => {
    setOpenMenus((prev) => {
      const isCurrentlyOpen = !!prev[id];
      if (isCurrentlyOpen) {
        return {};
      }
      return { [id]: true };
    });
  };

  // ============ FIXED: isMenuItemActive ============
  const isMenuItemActive = (item) => {
    const currentPath = location.pathname;

    // Exact match
    if (currentPath === item.path) {
      return true;
    }

    // Nested paths — sirf exact ya / ke saath
    if (item.nestedPaths) {
      for (const nestedPath of item.nestedPaths) {
        if (
          currentPath === nestedPath ||
          currentPath.startsWith(nestedPath + "/")
        ) {
          return true;
        }
      }
    }

    // Path + slash
    if (currentPath.startsWith(item.path + "/")) {
      return true;
    }

    return false;
  };

  const isSectionActive = (section) => {
    return section.items.some((item) => isMenuItemActive(item));
  };

  const closeSidebar = () => {
    if (window.innerWidth < 992) {
      setSidebarOpen(false);
    }
  };

  return (
    <nav
      id="sidebar"
      className={`sidebar-wrapper ${sidebarOpen ? "open" : ""}`}
    >
      <button
        type="button"
        className="sidebar-close-btn d-lg-none"
        aria-label="Close navigation"
        onClick={closeSidebar}
      >
        <FiX />
      </button>

      <div className="app-brand">
        <Link to="/" onClick={closeSidebar}>
          <img src={logo} className="logo" alt="Logo" />
        </Link>
      </div>

      <div className="sidebarMenuScroll">
        <div className="os-viewport">
          <div className="os-content">
            <ul className="sidebar-menu">
              {menuSections.map((section) => {
                const isOpen = openMenus[section.id] || false;
                const hasDropdown = section.items.length > 1;
                const Icon = section.icon;
                const isActiveSection = isSectionActive(section);

                return (
                  <React.Fragment key={section.id}>
                    {hasDropdown ? (
                      <li
                        className={`treeview ${isOpen ? "active" : ""} ${
                          isActiveSection ? "current-page" : ""
                        }`}
                      >
                        <Link to="#!" onClick={() => toggleMenu(section.id)}>
                          <Icon className="me-2" />
                          <span className="menu-text">{section.title}</span>
                          <FiChevronRight
                            className="menu_arrow"
                            style={{
                              transform: isOpen
                                ? "rotate(-90deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        </Link>
                        <ul
                          className="treeview-menu"
                          style={{
                            display: isOpen ? "block" : "none",
                          }}
                        >
                          {section.items.map((item) => {
                            const ItemIcon = item.icon;
                            const isActive = isMenuItemActive(item);

                            return (
                              <li
                                key={item.id}
                                className={
                                  isActive ? "active current-page" : ""
                                }
                              >
                                <Link to={item.path} onClick={closeSidebar}>
                                  <ItemIcon className="me-2" />
                                  <span className="menu-text">
                                    {item.label}
                                  </span>
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                    ) : (
                      <li
                        className={
                          isMenuItemActive(section.items[0])
                            ? "active current-page"
                            : ""
                        }
                      >
                        <Link to={section.items[0].path} onClick={closeSidebar}>
                          <Icon className="me-2" />
                          <span className="menu-text">
                            {section.items[0].label}
                          </span>
                        </Link>
                      </li>
                    )}
                  </React.Fragment>
                );
              })}
            </ul>
            <div className="logoutbutton">
              <Link to="/login" onClick={closeSidebar} className="">
                <FiPower />
                <span className="menu-text">Log Out</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
